// extracted by mini-css-extract-plugin
export var disk_card = "DiskCard-module--disk_card--STG3S";
export var disk_cover = "DiskCard-module--disk_cover--csU59";
export var disk_info = "DiskCard-module--disk_info--h95WI";
export var disk_title = "DiskCard-module--disk_title--vDeqx";
export var disk_data = "DiskCard-module--disk_data--4GRac";
export var disk_icons = "DiskCard-module--disk_icons--b9Tp2";
export var disk_streaming = "DiskCard-module--disk_streaming--ixQgH";